import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { operationsClient, apiPatch } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { bookingKeys, schedulerKeys } from '@/lib/queryKeys';
import type { SchedulerBooking, RescheduleBookingDto } from '@/types/scheduler';

/**
 * Reschedules an existing booking to a new slot.
 */
export function useRescheduleBooking(bookingId: string) {
  const queryClient = useQueryClient();

  return useApiMutation<SchedulerBooking, RescheduleBookingDto>({
    mutationFn: (dto) =>
      apiPatch<SchedulerBooking, RescheduleBookingDto>(
        operationsClient,
        schedulerEndpoints.reschedule(bookingId),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: schedulerKeys.bookings() });
      void queryClient.invalidateQueries({ queryKey: schedulerKeys.booking(bookingId) });
      void queryClient.invalidateQueries({ queryKey: bookingKeys.all() });
      void queryClient.invalidateQueries({ queryKey: bookingKeys.detail(bookingId) });
      toast.success('Booking rescheduled');
    },
  });
}
